/**
 * Use this to distinguish a local dev environment pointing to dev/staging/production backend
 * from an actual deployment to dev.mach.exchange or staging.mach.exchange.
 *
 * This is useful if we want to locally test features that are not enabled on
 * dev.mach.exchange or staging.mach.exchange.
 *
 * By default we enable every feature locally, modify if needed.
 */
const LOCAL_ANY = ['LOCAL_DEV', 'LOCAL_STAGING', 'LOCAL_PRODUCTION', 'LOCAL_TESTNET']

export const FEATURE_GATES: Readonly<Record<string, string[]>> = {
    ENABLE_TESTNETS: ['LOCAL_TESTNET', 'TESTNET', 'TESTNET_DEV'], // Whether we want to enable testnets as well
    USE_TESTNETS_ONLY: ['LOCAL_TESTNET', 'TESTNET', 'TESTNET_DEV'], // Whether we ONLY want to enable testnets.
    TRANSACTION_CAP: ['LOCAL_TESTNET', 'TESTNET', 'TESTNET_DEV'], // Whether we ONLY want to enable testnets.
    TRON_USDT_ONLY: [],
    SHOW_TRON_CHAIN: LOCAL_ANY.concat(['DEV', 'STAGING']), // gate all tron token assets on the tron network until backend is working
    USE_NEW_WALLET_PROVIDER: ['LOCAL_DEV'].concat(['DEV']), // Enable new wallet implementation for local and dev environments only
    ENABLE_EXPERIMENTAL_CHAINS: LOCAL_ANY.concat(['DEV', 'STAGING']), // Enable in non-prod environments
    MILES_REQUIREMENT: ['LOCAL_TESTNET', 'TESTNET', 'TESTNET_DEV'], // Gate MON/WMON purchases behind miles requirement on testnet
}
